import { FC, useMemo } from 'react';
import { Stack, Typography, TypographyProps } from '@mui/material';


interface Props extends TypographyProps {
  text?: string;
}

export const TimeEstimates: FC<Props> = ({ text, ...typographyProps }) => {
  const { readingTime, presentingTime } = useMemo(() => {
    const trimmedText = text?.trim();
    const wordCount = trimmedText ? trimmedText.split(/\s+/).filter(Boolean).length : 0;
    const readingTimeMinutes = wordCount / 225;
    const presentingTimeMinutes = wordCount / 125;
    const roundToNearestDecimal = (value: number) => Math.round(value * 10) / 10;
    
    return {
      readingTime: roundToNearestDecimal(readingTimeMinutes),
      presentingTime: roundToNearestDecimal(presentingTimeMinutes),
    };
  }, [text]);

  return (
    <Stack direction="column" spacing={0.5}>
      <Typography variant="caption" color="text.secondary" {...typographyProps}>
        📖 ≈ {readingTime.toFixed(1)} minute{readingTime !== 1 ? 's' : ''} (reading)
      </Typography>
      <Typography variant="caption" color="text.secondary" {...typographyProps}>
        🎤 ≈ {presentingTime.toFixed(1)} minute{presentingTime !== 1 ? 's' : ''} (presenting)
      </Typography>
    </Stack>
  );
};